import * as React from 'react';
import { createActivityAndActionPlan, getActionPlanList } from '../../api/actionPlanClientApi';
import { ActivityListingPageScaffold } from '../../features/activities/common/ActivityListingPageScaffold';
import { Redirect } from 'react-router-dom';
import { ActionPlanListView } from '../../amorg-common/DTOs/ActionPlanListView';
import { rng } from '../../amorg-common';
import { LoadingPageOverlay } from '../../designSystem/LoadingPageOverlay';
import { ActionPlanListingView } from './components/ActionPlanListingView';

type State = {
    activities: ActionPlanListView[],
};

export function ActionPlanListPage (): JSX.Element
{
    const [state, setState] = React.useState<State>({
        activities: []
    });
    const [loading, setLoading] = React.useState(true);
    const [redirectId, setRedirectId] = React.useState('');

    React.useEffect(() =>
    {
        const getData = async () =>
        {
            const actionPlans = await getActionPlanList();
            setState({ activities: actionPlans });
            setLoading(false);
        };
        getData();
    }, []);

    async function handleClickNewActionPlan ()
    {
        setLoading(true);

        const now = new Date();
        const tomorrow = new Date(now.getTime() + 1000 * 60 * 60 * 24); // Add one day
        tomorrow.setHours(8, 0, 0, 0);

        const fortnight = new Date(tomorrow.getTime() + 1000 * 60 * 60 * 24 * 14); // Add two weeks
        fortnight.setHours(16, 0, 0, 0);

        const activityId = rng.getRandomId();
        const actionPlanId = rng.getRandomId();

        const createActionPlanResult = await createActivityAndActionPlan(actionPlanId, activityId, { type: 'Independent' }, 'Ny handleplan', tomorrow, fortnight);
        if (!createActionPlanResult.isSuccess)
        {
            console.error('Failed to create action plan:', createActionPlanResult.errorMessage);
        }
        else
        {
            setLoading(false);
            setRedirectId(actionPlanId);
        }
    }

    const now = new Date();
    const currentActivities = state.activities.filter(a => a.end > now);
    const pastActivities = state.activities.filter(a => a.end <= now);

    return (
        <>
            <LoadingPageOverlay loading={loading} />

            {redirectId &&
                <Redirect to={`/actionplans/${redirectId}`} push={true} from="/actionplans" />
            }

            <ActivityListingPageScaffold
                selectedMenuItemKey='actionplans'
                headerText="Handleplaner"
                pastHeaderText="TIDLIGERE HANDLEPLANER"
                newActivityButtonText="Opret ny handleplan"
                toolBarButtons={null}
                currentActivities={currentActivities.map(a => ({
                    id: a.id,
                    component: <ActionPlanListingView key={a.id} item={a} />
                }))}
                pastActivities={pastActivities.map(a => ({
                    id: a.id,
                    component: <ActionPlanListingView key={a.id} item={a} />
                }))}
                onClickNew={handleClickNewActionPlan}
            />
        </>
    );
}